<nav-item label="Department"  [hideChevronRight]="true" [ngClass]="{'active': isActive()}">
    <svg-icon key="department" fontSize="1.5rem"></svg-icon>
</nav-item>
